<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="filter_headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID" v-bind:class="{ 'warning-line': item.IsFragileGoods || item.IsCheck || item.OrderGuarantee}">
                <td>{{ item.TransactionCode }}</td>
                <td>{{ item.OrderID > 0 ? (item.PackageType == 0 ? 'MD' : 'KG') + item.OrderID : ''}}</td>
                <td>
                  {{ item.IsFragileGoods ? 'Đóng gỗ' : '' }}
                  <br v-if="item.IsFragileGoods" />
                  {{ item.IsCheck ? 'Kiểm hàng' : '' }}
                  <br v-if="item.IsCheck" />
                  {{ item.OrderGuarantee ? 'Bảo hiểm' : '' }}
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.FeeShip"
                    large
                    lazy
                    persistent
                    @save="saveItem(item)"
                  >
                    <div>{{ item.FeeShip | currency('', 1)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.FeeShip"
                        type="number"
                        step=".1"
                        label="Phí ship"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.FeeFragileGoods"
                    large
                    lazy
                    persistent
                    @save="saveItem(item)"
                  >
                    <div>{{ item.FeeFragileGoods | currency('', 1)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.FeeFragileGoods"
                        type="number"
                        step=".1"
                        label="Phí gia cố"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.FeeOther"
                    large
                    lazy
                    persistent
                    @save="saveItem(item)"
                  >
                    <div>{{ item.FeeOther | currency('', 1)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.FeeOther"
                        type="number"
                        step=".1"
                        label="Phí khác"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-if="item.BigPackageID > 0 && getBigPackage(item.BigPackageID) == ''">
                  {{item.PackageCode}}
                </td>
                <td v-if="item.BigPackageID == 0 || getBigPackage(item.BigPackageID) != ''">
                  <v-edit-dialog
                    :return-value.sync="item.BigPackageID"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'BigPackageID': item.BigPackageID})"
                  >
                    <div>{{ item.PackageCode }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="packages"
                        v-model="item.BigPackageID"
                        item-text="PackageCode"
                        item-value="ID"
                        v-on:change="item.PackageCode = getBigPackage(item.BigPackageID)"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td>{{ item.StoreCNImportDate | display_date }}</td>
                <td>{{ item.PackDate | display_date }}</td>
                <td>{{ item.UserCode }}</td>
                <td>
                  <img
                    v-if="getFirstTransactionImage(item)"
                    :src="proxyImage(getFirstTransactionImage(item))"
                    class="transaction-preview-image"
                    @click="openGallery([getFirstTransactionImage(item)], 0)"
                  />
                </td>
                <td>
                  <div v-if="showDeclarationImages(item)" class="declaration-preview-list">
                    <img
                      v-for="(image, imageIdx) in getDeclarationImages(item)"
                      :key="`${item.ID}_declaration_${imageIdx}`"
                      :src="proxyImage(image)"
                      class="transaction-preview-image"
                      @click="openGallery(getDeclarationImages(item), imageIdx)"
                    />
                  </div>
                </td>
                <td class="truncate">
                  <v-edit-dialog :return-value.sync="item.OrderNote" large lazy persistent @save="saveItem({'ID': item.ID, 'OrderNote': item.OrderNote})">
                      <v-tooltip top right max-width="250">
                          <template v-slot:activator="{ on }">
                              <span v-on="on">{{ item.OrderNote }}</span>
                          </template>
                          <span>{{ item.OrderNote }}</span>
                      </v-tooltip>
                      <template v-slot:input>
                          <v-textarea v-model="item.OrderNote" label="Ghi chú" single-line autofocus></v-textarea>
                      </template>
                  </v-edit-dialog>
                </td>
                <td class="text-center">
                  <v-tooltip top>
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" v-if="(storeRole & 4)" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                      </template>
                      <span>Xóa mã vận đơn</span>
                  </v-tooltip>
                  
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <store-popup
        :dialogStoreManager="dialogStoreManager"
        v-on:closePopup="closePopup"
        @deleteItem="deleteItem"
      ></store-popup>
      <upload-file :dialogUpload="dialogImport" title="Import mã vận đơn" temp_file="/nhap_kho_tq.xlsx" @closePopup="dialogImport=false" @importFile="importFile"></upload-file>
      <v-overlay :value="storeManagerLoading" z-index="999999">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
      </v-overlay>
      <gallery :images="galleryImages" :index="galleryIndex" @close="galleryIndex = null"></gallery>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import store from "@/components/popups/store";
import { sendErrorNotice } from "@/commons/utils";
import { getFirstImage, parseImageList, proxyImage } from "@/commons/utils";
import upload_file from "@/components/popups/upload_file";
import VueGallery from "vue-gallery";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
    "upload-file": upload_file,
    "store-popup": store,
    gallery: VueGallery
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Mã đơn hàng",
          value: "OrderID",
          filterable: true,
          quickSearch: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cảnh báo",
          sortable: false,
          filterable: false,
        },
        {
          text: "Phí ship",
          value: "FeeShip",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí gia cố",
          value: "FeeFragileGoods",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí khác",
          value: "FeeOther",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Mã bao hàng",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Ngày nhập kho",
          value: "StoreCNImportDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Ngày đóng bao",
          value: "PackDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Khách hàng",
          value: "UserCode",
          filterable: true,
          width: "150px",
          dataType: dataType["String"]
        },
        {
          text: "Ảnh",
          value: "StoreCNImages",
          sortable: false,
          filterable: false
        },
        {
          text: "Hình ảnh khai báo",
          value: "DeclarationImages",
          sortable: false,
          filterable: false
        },
        {
          text: "Ghi chú",
          value: "OrderNote",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "storemanager_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogStoreManager: false,
      dialogEditTranCode: false,
      dialogImport: false,
      galleryImages: [],
      galleryIndex: null
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    storeRole() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.storeRole & 2)});
    }
  },
  computed: {
    ...mapState({
      items: state => state.orderTransaction.all.data,
      total_rows: state => state.orderTransaction.all.total,
      currentItem: state => state.orderTransaction.selected,
      loading: state => state.orderTransaction.loading,
      packages: state => state.bigPackage.inTQ,
      guarantees: state => {
        let tmp = [{name: 'Không sử dụng', value: 0}];
        if(state.feeGuarantee.all.data) {
        state.feeGuarantee.all.data.forEach(element => {
            tmp.push({name: element.PackageName, value: element.ID});
        });
        }
        return tmp;
      },
      storeManagerLoading: state => state.storeManager.loading,
    }),
    storeRole() {
      return this.$store.state.authentication.role.StoreCN;
    },
    param() {
      let pr = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      pr.filter.push({
        column: "Status",
        value: [configs.PACKAGE_STATUS_ENUM.DA_VE_TQ, configs.PACKAGE_STATUS_ENUM.DANG_VE_VN],
        condition: "in"
      });
      return pr;
    },    
    filter_headers() {
      let tmp = [...this.headers];
      tmp.push({
          text: "Đóng gỗ",
          value: "IsFragileGoods",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: "Kiểm hàng",
          value: "IsCheck",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        });
      tmp.push({
          text: "Bảo hiểm",
          value: "OrderGuarantee",
          filterable: true,
          values: this.guarantees,
          dataType: configs.DATA_TYPE["Enum"]
        });
      return tmp;
    },
  },
  methods: {
    proxyImage,
    filter_data: function() {
      this.$store.dispatch("bigPackage/getListInTQ");
      this.$store.dispatch("orderTransaction/getList", this.param);
      this.$store.dispatch("feeGuarantee/getList");
    },
    gotoDetail: function(id) {
      let item = _.find(this.items, { ID: id });
      this.$store.commit("orderTransaction/setDetail", { data: item });
      this.dialogEditTranCode = true;
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      if(this.storeRole & 2) {
        this.$store.commit("orderTransaction/setDetail", {
          data: {
            ID: 0,
            TransactionCode: "",
            FeeShip: 0
          }
        });
        this.dialogStoreManager = true;
      }
      else {
        sendErrorNotice("Bạn không có quyền thêm mới!");
      }
    },
    saveItem(item) {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          ...item,
          'TransactionView': 'store_tq'
        },
        id: item.ID,
        param: this.param
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogEditTranCode = false;
    },
    closePopup() {
      this.dialogStoreManager = false;
      this.filter_data();
    },
    getBigPackage(bigPackageID) {
      const item = _.find(this.packages, {ID: bigPackageID});
      return item ? item.PackageCode : '';
    },
    onImport() {
      this.dialogImport = true;
    },
    importFile(filelist) {
      for(const f of filelist) {
        const formData = new FormData();
        formData.append('excel_file', f);
        formData.append('filename', f.name);
        this.$store.dispatch("storeManager/import_transaction", formData);
      }
      this.dialogImport = false;
    },
    getFirstTransactionImage(item) {
      return getFirstImage(item && item.StoreCNImages);
    },
    getDeclarationImages(item) {
      return parseImageList(item && item.DeclarationImages);
    },
    showDeclarationImages(item) {
      return item && item.OrderType === 'NKCN' && this.getDeclarationImages(item).length > 0;
    },
    openGallery(images, index) {
      if (!images || images.length === 0) return;
      this.galleryImages = images.map(img => this.proxyImage(img));
      this.galleryIndex = index;
    },
    getCurrentGalleryPrintImage() {
      const activeImage = document.querySelector('.blueimp-gallery .slide-active img');
      if (activeImage && activeImage.src) {
        return activeImage.src;
      }

      if (
        Array.isArray(this.galleryImages) &&
        this.galleryImages.length > 0 &&
        this.galleryIndex !== null &&
        this.galleryImages[this.galleryIndex]
      ) {
        return this.galleryImages[this.galleryIndex];
      }

      return "";
    },
    _beforePrint() {
      const gallery = document.querySelector('.blueimp-gallery');
      if (!gallery || !gallery.classList.contains('blueimp-gallery-display')) return;

      const imageSrc = this.getCurrentGalleryPrintImage();
      if (!imageSrc) return;

      this._printStyleEl = document.createElement('style');
      this._printStyleEl.innerHTML = [
        'body > * { display: none !important; }',
        '.gallery-print-layer { display: flex !important; position: fixed !important; inset: 0 !important; width: 100vw !important; height: 100vh !important; align-items: center !important; justify-content: center !important; background: #fff !important; z-index: 1000000 !important; }',
        '.gallery-print-layer img { display: block !important; max-width: 100vw !important; max-height: 100vh !important; object-fit: contain !important; margin: auto !important; }'
      ].join(' ');
      document.head.appendChild(this._printStyleEl);

      this._printLayerEl = document.createElement('div');
      this._printLayerEl.className = 'gallery-print-layer';

      const printImage = document.createElement('img');
      printImage.src = imageSrc;
      this._printLayerEl.appendChild(printImage);

      document.body.appendChild(this._printLayerEl);
    },
    _afterPrint() {
      if (this._printStyleEl) {
        document.head.removeChild(this._printStyleEl);
        this._printStyleEl = null;
      }

      if (this._printLayerEl) {
        document.body.removeChild(this._printLayerEl);
        this._printLayerEl = null;
      }
    }
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.storeRole & 2)});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("REQUEST_OTHER_ACTION", this.onImport);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          'RequestAction': 'DEL',
          'TransactionView': 'store_cn'
        },
        'id': id,
        param: this.param
      });
    });
    window.addEventListener('beforeprint', this._beforePrint);
    window.addEventListener('afterprint', this._afterPrint);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("REQUEST_OTHER_ACTION", this.onImport);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
    window.removeEventListener('beforeprint', this._beforePrint);
    window.removeEventListener('afterprint', this._afterPrint);
  }
};
</script>
<style scoped>

.transaction-preview-image {
  width: 52px;
  height: 52px;
  object-fit: cover;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid #d7d7d7;
}

.declaration-preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-width: 180px;
}
</style>
